import { Component, Inject, OnInit } from '@angular/core';
import { ValidacionComponent } from '../../validacion.component';

@Component({
  selector: 'app-validacion-inicio',
  templateUrl: './validacion-inicio.component.html',
  styleUrls: ['./validacion-inicio.component.css']
})
export class ValidacionInicioComponent implements OnInit {

  ngOnInit(): void {
  }
}
